import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SectionWrapper } from 'src/components/Reports/Report.style';
import { ReportsFilterV2 } from 'src/components/Reports/ReportsFilter/ReportsFilterV2';
import { ReportsListNew } from 'src/components/Reports/ReportsList/ReportsListNew';

export const ReportV2 = observer('RaportV2', (): React.ReactElement => {
    return (
        <SectionWrapper className='reports'>
            <ReportsFilterV2 />
            <ReportsListNew />
        </SectionWrapper>
    );
});
